import React from 'react';

const RoofDeck = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M13.125 27.1875H25.3125"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2866 8.95585C12.2214 9.08609 12.1875 9.22973 12.1875 9.37538C12.1875 9.52102 12.2214 9.66466 12.2866 9.79491L16.0108 17.2949C16.0888 17.4507 16.2086 17.5816 16.3568 17.6731C16.505 17.7646 16.6757 17.813 16.8499 17.8129H24.3757C24.6243 17.8129 24.8628 17.9116 25.0386 18.0875C25.2144 18.2633 25.3132 18.5017 25.3132 18.7504V22.5004C25.3132 22.749 25.2144 22.9875 25.0386 23.1633C24.8628 23.3391 24.6243 23.4379 24.3757 23.4379H13.3729C13.199 23.4378 13.0285 23.3893 12.8805 23.2978C12.7325 23.2063 12.6129 23.0755 12.535 22.9199L5.72411 9.32616C5.65893 9.19591 5.625 9.05227 5.625 8.90663C5.625 8.76098 5.65893 8.61734 5.72411 8.4871L8.32098 3.33085C8.43234 3.10871 8.62733 2.93987 8.86311 2.86142C9.09889 2.78297 9.35616 2.80134 9.57841 2.91249L13.5499 4.58944C13.772 4.7008 13.9409 4.89579 14.0193 5.13156C14.0978 5.36734 14.0794 5.62462 13.9682 5.84686L12.2866 8.95585Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RoofDeck;
